import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ScaleIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-navy text-white relative" data-id="element-81">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <FadeIn data-id="element-83">
          <div className="relative bg-navy-light rounded-2xl p-8 md:p-12 border-2 border-gold shadow-2xl" data-id="element-84">
            {/* Decorative corner accents */}
            <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-gold -translate-x-1 -translate-y-1" data-id="element-85"></div>
            <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-gold translate-x-1 -translate-y-1" data-id="element-86"></div>
            <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-gold -translate-x-1 translate-y-1" data-id="element-87"></div>
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-gold translate-x-1 translate-y-1" data-id="element-88"></div>

            <div className="flex flex-col items-center text-center mb-8" data-id="element-89">
              <div className="bg-gold/10 p-4 rounded-full mb-6" data-id="element-90">
                <ScaleIcon className="w-10 h-10 text-gold" data-id="element-91" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gold mb-4" data-id="element-92">
                El Mecanismo de Verificación Forzada
              </h2>
              <p className="text-lg text-gray-300 font-sans tracking-wide uppercase text-sm font-semibold" data-id="element-93">
                (Ley FCRA - Sección 611)
              </p>
            </div>

            <div className="space-y-6 text-lg text-gray-200 font-sans leading-relaxed" data-id="element-94">
              <p data-id="element-95">
                Utilizamos la sección 611 de la Ley Federal de Reporte Justo de
                Crédito. No "pedimos por favor" que borren una deuda;{' '}
                <strong className="text-white font-bold" data-id="element-96">
                  exigimos que prueben
                </strong>{' '}
                que cada punto y coma de esa deuda es 100% exacto.
              </p>
              <p data-id="element-97">
                Si el cobrador no tiene el contrato original o violó tu
                privacidad HIPAA (en deudas médicas), la ley los{' '}
                <strong className="text-gold font-bold" data-id="element-98">
                  OBLIGA a borrar el registro
                </strong>{' '}
                de tu historial para siempre.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}